<template>
  <div class="">
    <div
      v-if="showBackButton"
      class="d-flex justify-content align-items-center mb-1 cursor-pointer"
      @click="validateGoBack()"
    >
      <button
        class="btn btn-sm rounded-circle p-25"
        :class="isDark ? 'btn-danger' : 'btn-primary'"
      >
        <i class="feather icon-arrow-left arrow-icon"></i>
      </button>
      <div class="ml-1 text-capitalize text-dark goback-text">
        {{ $t("actions.go_back") }}
      </div>
    </div>
    <b-progress :value="(currentStep / totalSteps) * 100" height="2px" class="mb-2" />
    <div v-show="currentStep === 1">
      <h5 class="mb-2">{{ $t("operational_security.evaluation.select_form") }}</h5>
      <div class="">
        <v-select
          v-model="templateSelected"
          :options="templatesOptions"
          :filterable="false"
          @search="onSearch"
          @input="setTemplatePreview"
          label="name"
          :clearable="false"
          :placeholder="$t('operational_security.select_form_place_holder')"
          ref="selectable"
        >
          <!-- <template #list-footer>
              <li class="pagination">
                <b-button
                  :disabled="currentPage === 1"
                  variant="outline-primary"
                  size="sm"
                  @click="updateCurrentPage('prev')"
                >
                  <feather-icon icon="ChevronLeftIcon" size="18"/>
                </b-button>
                <b-button
                  :disabled="lastPage === currentPage"
                  variant="outline-primary"
                  size="sm"
                  @click="updateCurrentPage('next')"
                >
                  <feather-icon icon="ChevronRightIcon" size="18"/>
                </b-button>
              </li>
            </template> -->
        </v-select>
      </div>

      <!-- preview -->
      <div class="mt-1" v-if="templateSelected && !isAnsweringForm">
        <b-button variant="secondary" @click="startAnsweringForm">
          {{ $t("risk.answer_form") || "Responder formulario" }}
        </b-button>
      </div>
    </div>

    <div class="" v-if="currentStep === 2"></div>

    <div class="header-grid mb-1" v-if="isAnsweringForm">
      <div class="info-card">
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="4">
            <div v-if="showReferenceNumber" class="info-row">
              <span class="info-label">{{ $t("risk.reference_number") }}:</span>
              <span class="info-value">{{ referenceShowed }}</span>
            </div>
            <div class="info-row">
              <span class="info-label"
                >{{ $tc("operational_security.template.title", 1) }}:</span
              >
              <span class="info-value">{{ templateName }}</span>
            </div>

            <div class="info-row" v-if="alarmType && alarmType.id">
              <span class="info-label">{{ $tc("alarm.title", 1) }}:</span>
              <div
                class="d-flex align-items-center gap-2 cursor-pointer"
                @click="openAlarm"
              >
                <custom-icon
                  v-if="alarmType.icon"
                  :name="alarmType.icon"
                  :color="alarmType.color"
                  size="18"
                  title=""
                />
                <span
                  class="customBadgeForm"
                  :style="{ backgroundColor: alarmType.color || '#971f1e' }"
                >
                  {{ alarmType.acronym }}
                </span>

                <span style="text-decoration: underline">{{
                  alarmType.description
                }}</span>
              </div>
            </div>

            <div class="info-row" v-if="ownerOfForm && ownerOfForm.full_name">
              <span class="info-label">{{ $tc("alarm.created_by", 1) }}:</span>
              <span class="info-value">{{ ownerOfForm.full_name }}</span>
            </div>
          </b-col>
          <b-col cols="12" md="8" v-if="currentEvaluation && currentEvaluation.recipient_emails">
            <p class="info-label">{{ $t("operational_security.evaluation.sent_to") }}</p>

            <div class="d-flex flex-column">
              <!--<a href="#" class="mb-1" v-for="(relatedForm, index) in relatedTemplates" :key="index">
                {{ relatedForm.name }}

              </a>-->
              <div
                v-for="(email, index) in recipientEmails"
                :key="index"
              >
                <p class="mb-0">
                  {{ email }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>

        <div class="d-flex justify-content flex-wrap">
          <div class="">
            <div v-if="formTracking.length > 0" class="mt-2 mr-4">
              <div class="d-flex align-items-center mb-1">
                <span class="info-label"
                  >{{ $t("operational_security.evaluation.related_forms") }}:</span
                >
              </div>
              <div class="timeline-container mr-4">
                <div
                  v-for="form in formTracking"
                  :key="form.id"
                  class="timeline-item"
                  :class="{ 'active-form': form.id === evaluation_id }"
                  @click="form.id !== evaluation_id && navigateToForm(form.id)"
                  draggable="true"
                  @dragstart="onDragStartFormTracking(form)"
                >
                  <div class="timeline-dot"></div>
                  <div class="timeline-content">
                    <div class="timeline-header">
                      <span class="timeline-reference">{{ form.reference }}</span>
                      <span
                        class="timeline-badge"
                        :class="form.is_mailable ? 'badge-mailable' : 'badge-standard'"
                      >
                        {{
                          form.is_mailable
                            ? $t("operational_security.evaluation.mailable")
                            : $t("operational_security.evaluation.standard")
                        }}
                      </span>
                    </div>
                    <div class="timeline-template">{{ form.template }}</div>
                    <div class="timeline-meta">
                      <small>{{ form.user.full_name }}</small>
                      <small class="text-muted">{{ form.created_at }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="isLoadingTracking" class="mt-2">
              <b-spinner small></b-spinner>
              <span class="ml-1">{{
                $t("operational_security.evaluation.loading_tracking")
              }}</span>
            </div>
          </div>

          <!-- Form history -->
          <div class="mt-3 mr-4">
            <div class="history-card card">
              <div
                class="history-header d-flex align-items-center justify-content-between"
              >
                <strong>{{ $t("custom_forms.history") }}</strong>
                <small class="text-muted">
                  {{ formHistory.length }}
                  {{ $t("custom_forms.entries") }}
                </small>
              </div>

              <div class="history-table" v-if="formHistory.length">
                <div class="history-row history-row--head bg-transparent">
                  <div class="col-state text-body">{{ $t("custom_forms.state") }}</div>
                  <div class="col-user text-body">{{ $t("custom_forms.user") }}</div>
                  <div class="col-date text-body">{{ $t("custom_forms.date") }}</div>
                  <!-- <div v-if="hasHistoryComments" class="col-note text-body">
                    {{ tf('custom_forms.note', 'Nota') }}
                  </div> -->
                </div>

                <div
                  v-for="s in formHistory"
                  :key="s.id"
                  class="history-row-item-container"
                >
                  <div class="history-row-item">
                    <div class="col-state">
                      <b-badge
                        pill
                        :variant="getStatusVariant(s.status)"
                        class="history-badge"
                      >
                        {{ getStatusLabel(s.status) }}
                      </b-badge>
                    </div>
                    <div class="col-user">
                      <div class="history-user" :title="formatUser(s)">
                        <div class="user-name text-body">{{ getUserName(s) || "—" }}</div>
                        <div v-if="getUserEmail(s)" class="user-email text-body">
                          {{ getUserEmail(s) }}
                        </div>
                      </div>
                    </div>
                    <div class="col-date">
                      <small class="history-date text-body">{{
                        formatDate(
                          s.approved_at || s.rejected_at || s.reopened_at || s.created_at
                        )
                      }}</small>
                    </div>
                  </div>
                  <div class="history-row-item__comments">
                    {{ s.comments || s.reopened_comments }}
                  </div>
                </div>
              </div>
              <div v-else class="text-muted small py-1">
                {{ $t("custom_forms.empty") }}
              </div>
            </div>
          </div>

          <!-- Direct links -->
          <div class="mt-4">
            <p class="lead">{{ $t("operational_security.evaluation.shortcuts") }}</p>

            <div class="d-flex flex-column">
              <!--<a href="#" class="mb-1" v-for="(relatedForm, index) in relatedTemplates" :key="index">
                {{ relatedForm.name }}

              </a>-->
              <div
                class="mb-1"
                v-for="(relatedForm, index) in relatedTemplates"
                :key="index"
              >
                <span
                  class="entity-link mr-1"
                  @click="openCreateNewFormType(currentEvaluation, relatedForm)"
                >
                  {{ relatedForm.name }}
                </span>
                <feather-icon
                  icon="ExternalLinkIcon"
                  size="16"
                  class="cursor-pointer text-primary"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <BuildForm
        ref="buildFormComponent"
        v-if="isAnsweringForm"
        :templateId="returnTemplateId()"
        :idUnit="returnFacilityId()"
        :unit="returnFacilityObj()"
        :evaluationId="evaluation_id"
        :reference="referenceNumber"
        @submit="onAnswersSubmit"
        @submitError="submitError"
        :idPrefill="idPrefill"
        :eventComment="comment"
        @onAfterGetTemplate="onAfterGetTemplate"
        :isCreateSpecialForms="isCreateSpecialForm"
        :idFormAnswerOwner="idFormAnswerOwner"
        :currentSpecialForm="currentSpecialForm"
        :currentFormData="currentEvaluation"
        :currentState="currentFormStatus"
        :anotherFacility="anotherFacility"
        :dataToReplace="dataToReplace"
        :isFormFromSameUser="isFormFromSameUser"
      />

      <!-- Evaluation form here -->
      <div
        class="container d-flex flex-column w-100 mb-4"
        v-if="(evaluation_id && showActionsButtons && !isReadOnlyUser) && !templateSelected.allow_draft "
      >
        <div v-if="canApproveForm || canRejectForm" class="mb-2">
          <v-select
            :key="userOptions.length"
            v-model="userSelected"
            :options="userOptions"
            :placeholder="$t('custom_forms.assigned_to')"
            label="label"
            :filter-by="filterUserOption"
            class="comment-box"
            :disabled="isStatusBeingUpdated"
          />
        </div>

        <!-- Reopened comments -->
        <div v-if="formStatus.isReopened && reopenedComments">
          <div class="header-grid info-card d-flex flex-column mb-1">
            <span class="mb-1"
              >{{ $t("operational_security.evaluation.reopened_comments") }} -
              {{ formatDate(formValidationRejectedAt) }}</span
            >
            <span>{{ reopenedComments }}</span>
          </div>
        </div>

        <!-- Validation comments -->
        <div v-if="formValidationComment">
          <div
            class="header-grid info-card d-flex flex-column mb-1"
            v-if="formValidationComment"
          >
            <span class="mb-1"
              >{{ $t("operational_security.evaluation.validation_comments") }} -
              {{ formatDate(formValidationAt) }}</span
            >
            <span>{{ formValidationComment }}</span>
          </div>
        </div>

        <!-- security manager comments -->
        <div v-if="significantEventSecManagerComment">
          <div
            class="header-grid info-card d-flex flex-column mb-1"
          >
            <span class="mb-1"
              >{{ $t("operational_security.sec_manager_comments") }} -
              {{ formatDate(significantEventSecManagerCommentDate) }}</span
            >
            <span>{{ significantEventSecManagerComment }}</span>
          </div>
        </div>

        <!-- Send to review comments -->
        <div v-if="canApproveForm || canRejectForm" class="mb-1">
          <b-form-group
            class="text-capitalize"
            :label="$t('custom_forms.review_comments')"
            label-for="validation_comment"
          >
            <b-form-textarea
              class="comment-box"
              id="validation_comment"
              v-model="validationComment"
              rows="3"
              max-rows="6"
              :disabled="isStatusBeingUpdated"
            ></b-form-textarea>
          </b-form-group>
          <div class="significantEvent" v-if="templateSelected.allow_significant_event">
            <div class="font-weight-bold">{{ $t('custom_forms.significant_event') }}</div>
            <b-form-checkbox
              v-model="isSignificantEvent"
              switch
              size="sm"
              class="mb-0 mx-0"
              :disabled="isStatusBeingUpdated"
              @change="onChangeIsSignificantEvent"
            />
            <div v-if="isSignificantEvent">
              <b-form-input
                style="min-width: 200px;max-width: 450px;"
                id="significantEvenTitle"
                v-model="significantEventTitle"
                type="text"
                :disabled="isStatusBeingUpdated"
                :placeholder="$t('custom_forms.significant_event_title')"
                class="mt-1 ml-1"
              />
              <b-form-textarea
                class="comment-box ml-1 mt-1"
                id="significantEventDescription"
                v-model="significantEventDescription"
                rows="3"
                max-rows="6"
                :disabled="isStatusBeingUpdated"
                :placeholder="$t('custom_forms.significant_event_description')"
              ></b-form-textarea>
              <v-select
                :key="userOptions.length"
                v-model="significantSecurityManager"
                :options="regionalManagerOptions"
                :placeholder="$t('custom_forms.significant_event_regional_manager')"
                label="label"
                class="comment-box mt-1 ml-1"
                :disabled="isStatusBeingUpdated"
              />
            </div>
          </div>
        </div>

        <!-- Send to review buttons -->
        <div class="d-flex mb-3">
          <b-button
            v-if="canApproveForm"
            variant="success"
            class="mr-1"
            @click="sendEvaluationFormStatus('approve')"
            :disabled="!validationComment || isStatusBeingUpdated"
          >
            {{ $t("actions.approve") }}
          </b-button>
          <div class="d-flex" v-if="canRejectForm">
            <b-button
              variant="danger"
              @click="sendEvaluationFormStatus('reject')"
              :disabled="!validationComment || isStatusBeingUpdated"
            >
              {{ $t("actions.reject") }}
            </b-button>
          </div>
        </div>

        <!-- Send to review -->
        <div v-if="isMarkerCheckerFlowAllowed && canUserSendToReview">
          <v-select
            :key="userOptions.length"
            v-model="userSelected"
            :options="userOptions"
            :placeholder="$t('custom_forms.assigned_to')"
            label="label"
            :filter-by="filterUserOption"
            class="comment-box mb-1"
            :disabled="isStatusBeingUpdated || (hasBauComplementsQuery && isBauBatchInProgress)"
          />
          <template v-if="hasBauComplementsQuery">
            <b-button
              variant="warning"
              class="ml-auto mb-3"
              @click="notifyAndCompleteBau(currentEvaluation)"
              :disabled="!userSelected || isStatusBeingUpdated || isBauBatchInProgress"
            >
              Notificar
            </b-button>
          </template>
          <template v-else> 
            <b-button
              variant="warning"
              class="ml-auto mb-3"
              @click="sendToReview(currentEvaluation)"
              :disabled="!userSelected || isStatusBeingUpdated"
            >
              {{ $t("custom_forms.send_to_review") }}
            </b-button>
          </template>
        </div>

        <!-- Reopen form -->
        <div
          v-if="isMarkerCheckerFlowAllowed && canUserReopenForm"
          class="d-flex flex-column align-items-start mb-4"
        >
          <v-select
            :key="userOptions.length"
            v-model="userSelected"
            :options="userOptions"
            :placeholder="$t('custom_forms.assigned_to_reopen')"
            class="mb-2 comment-box"
            label="label"
            :filter-by="filterUserOption"
            :disabled="isStatusBeingUpdated"
          />
          <div class="mb-2 comment-box">
            <b-form-group
              class="text-capitalize comment-box"
              :label="$t('action_plan.viewer.comments')"
              label-for="validation_comment"
            >
              <b-form-textarea
                id="reopenend_comment"
                v-model="reopenedComment"
                rows="3"
                max-rows="6"
                class="comment-box"
                :disabled="isStatusBeingUpdated"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <b-button
            :disabled="!userSelected || isStatusBeingUpdated || !reopenedComment"
            variant="warning"
            @click="reopenForm(currentEvaluation)"
          >
            {{ $t("custom_forms.reopen") }}
          </b-button>
        </div>

        <!-- Send by emails buttons -->
        <!--<div v-if="currentEvaluation">
          <div v-if="formStatus.isCompleted && currentEvaluation.is_mailable && isUserSupervisor" class="d-flex mb-4">
            <b-button variant="info" @click="sendEmailForm(currentEvaluation)" :disabled="isStatusBeingUpdated">
              {{ $t("operational_security.evaluation.send_form") }}
            </b-button>
          </div>

          <div v-else-if="formStatus.isCompleted && currentEvaluation.is_mailable && currentEvaluation.is_correo_informativo" class="d-flex mb-4">
            <b-button variant="info" @click="sendEmailForm(currentEvaluation)" :disabled="isStatusBeingUpdated">
              {{ $t("operational_security.evaluation.send_form") }}
            </b-button>
          </div>
        </div>-->
      </div>

      <!-- Significant event comments -->
      <div>
        <div
          class="container d-flex flex-column mb-4"
          v-if="
          formStatus.isCompleted
          && templateSelected.allow_significant_event
          && !significantEventSecManagerComment
          && $can('add_comment_to_significant_event', 'OpSecurityFormAnswers')"
        >
          <div class="mb-2 comment-box">
            <b-form-group
              class="text-capitalize comment-box"
              :label="$t('operational_security.security_manager_comments')"
              label-for="validation_comment"
            >
              <b-form-textarea
                id="reopenend_comment"
                v-model="significantEventDescription"
                rows="3"
                max-rows="6"
                class="comment-box"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <b-button
            variant="info"
            size="md"
            :block="false"
            @click="saveSignificantEventManagerComments"
          >
            {{ $t("operational_security.save_comments") }}
          </b-button>
        </div>
      </div>

      <!-- close form manually -->
      <div class="container" v-if="evaluation_id && !formStatus.isCompleted && isOwnerOfForm && canCloseFormManually">
        <b-button
            @click="closeForm"
            variant="success"
            :disabled="isStatusBeingUpdated"
          >
            {{ $t('operational_security.close_horizontal_form') }}
          </b-button>
      </div>

      <!-- Evaluation form here -->
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import useEvaluationForm from "./useEvaluationForm";
import vSelect from "vue-select";
import BuildForm from "./BuildForm";
import useLayoutSlots from "@/composables/layoutSlots";
import { SLOT_TYPES } from "@/config/layoutConfig";
import { computed } from "@vue/composition-api";
import store from "@/store";
import { curryRight } from "lodash";

export default {
  props: {
    location: {
      type: String,
      default: "modal",
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    evaluationId: {
      default: null,
    },
    evaluation: {
      default: null,
    },
    formValidationData: {
      default: null,
    },
    isPrefill: {
      default: false,
    },
    prefillData: {
      default: null,
    },
    isCreate: {
      default: false,
    },
    isCreateRegistration: {
      default: false,
    },
    isCreateSpecialForms: {
      default: false,
    },
    currentSpecialForms: {
      default: null,
    },
    idFormAnswerOwner: {
      default: null,
    },
    dataToReplace: {
      default: null,
    },
    openFromUrlParam: {
      default: false,
    },
    currentUrlParam: {
      default: null,
    },
    initialTemplateId: {
      type: [Number, String],
      default: null,
    },
    initialUnit: {
      default: null,
    },
  },
  components: {
    vSelect,
    BuildForm,
  },
  setup(props, { emit, root }) {
    const idPrefill = ref(null);
    const comment = ref(null);
    const {
      ownerOfForm,
      isOwnerOfForm,
      templatesOptions,
      currentPage,
      lastPage,
      currentStep,
      totalSteps,
      templateSelected,
      referenceNumber,
      facilitySelected,
      facilityOptions,
      templatePreview,
      isAnsweringForm,
      facilityName,
      templateName,
      formStatus,
      currentFormStatus,
      showActionsButtons,
      disabledUnitSelect,
      isStatusBeingUpdated,
      isBauBatchInProgress,
      isCreate,
      isPrefill,
      userSelected,
      userOptions,
      user,
      validationComment,
      formValidationComment,
      formValidationRejectedAt,
      formValidationAt,
      isCreateSpecialForm,
      referenceShowed,
      currentSpecialForm,
      anotherFacility,
      isShowAnotherFacility,
      reopenedComments,
      reopenedComment,
      formTracking,
      isLoadingTracking,
      showReferenceNumber,
      alarmType,
      formHistory,
      isUserSupervisor,
      isFormFromSameUser,
      evaluation_id,
      canUserSendToReview,
      hasBauComplementsQuery,
      isVisitsInmueblesTemplate,
      canRejectForm,
      canApproveForm,
      canUserReopenForm,
      currentEvaluation,
      isReadOnlyUser,
      isMarkerCheckerFlowAllowed,
      buildFormComponent,
      isSignificantEvent,
      significantEventTitle,
      significantEventDescription,
      significantSecurityManager,
      regionalManagerOptions,
      significantEventSecManagerComment,
      significantEventSecManagerCommentDate,
      canCloseFormManually,
      onSearch,
      fetchList,
      updateCurrentPage,
      checkRiskPercentage,
      setTemplatePreview,
      startAnsweringForm,
      onAnswersSubmit,
      setFacilityConfig,
      setReferenceNumber,
      submitError,
      sendToReview,
      sendBauNotificationTask,
      notifyAndCompleteBau,
      filterUserOption,
      sendEvaluationFormStatus,
      onAfterGetTemplate,
      reopenForm,
      // sendEmailForm,
      showAnotherFacility,
      fetchFormTracking,
      validateIfUrlHasParams,
      clearForm,
      loadFormData,
      validateGoBack,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      getStatusLabel,
      getStatusVariant,
      openAlarm,
      onChangeIsSignificantEvent,
      saveSignificantEventManagerComments,
      closeForm
    } = useEvaluationForm(
      props.location,
      props.formValidationData,
      props.initialTemplateId,
      emit
    );

    const { setSlotData } = useLayoutSlots();

    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");
    const recipientEmails = computed(() => currentEvaluation.value?.recipient_emails || []);
    const shouldHideReopenSection = computed(
      () => hasBauComplementsQuery.value || isVisitsInmueblesTemplate.value
    );

    const relatedTemplates = ref([]);

    const navigateToForm = (formId) => {
      emit("navigate-to-form", formId);
    };

    const openCreateNewFormType = (form, type) => {
      emit("openCreateNewFormType", form, type, true);
    };

    const onDragStartFormTracking = (form) => {
      setSlotData(
        SLOT_TYPES.OPERATIONAL_SECURITY_FORM,
        `operational_security_form`,
        form
      );
    };

    onMounted(async () => {
      evaluation_id.value = props.evaluationId;
      currentEvaluation.value = props.evaluation;
      relatedTemplates.value = currentEvaluation.value?.template?.related_templates;
      validateIfUrlHasParams(props.openFromUrlParam, props.currentUrlParam);
      referenceShowed.value = setReferenceNumber();
      setReferenceNumber();
      disabledUnitSelect.value = false;

      if (props.prefillData) {
        facilitySelected.value = props.prefillData.unit;
        disabledUnitSelect.value = true;
        comment.value = props?.dataToReplace?.comentarios ?? null;
      }
      if (props.isPrefill) {
        idPrefill.value = props.prefillData?.id;
        isPrefill.value = props.isPrefill;
      }

      if (evaluation_id.value) {
        loadFormData();
        templateSelected.value = currentEvaluation.value?.template;
        facilitySelected.value = currentEvaluation.value?.unit;
        disabledUnitSelect.value = true;
        fetchFormTracking(evaluation_id.value);

        // Reiniciar el formulario
        isAnsweringForm.value = false;
        setTimeout(() => {
          startAnsweringForm();
        }, 50);
        return;
      }

      isCreate.value = props.isCreateRegistration ? false : props.isCreate;
      if (props.isCreateSpecialForms) {
        currentSpecialForm.value = props.currentSpecialForms;
        isCreateSpecialForm.value = props.isCreateSpecialForms;
        isCreate.value = false;
        comment.value = props?.dataToReplace?.comentarios ?? null;
        if (props.initialUnit) {
          facilitySelected.value = props.initialUnit;
          disabledUnitSelect.value = true;

          if (
            props.initialUnit.id_municipality &&
            !store.state.municipality?.items?.length
          ) {
            await store.dispatch("municipality/getAll");
          }
        }
      }

      // Handle initialUnit for startForm flow (from alarm dropdown)
      if (!props.isCreateSpecialForms && props.initialTemplateId && props.initialUnit) {
        facilitySelected.value = props.initialUnit;
        disabledUnitSelect.value = true;

        if (
          props.initialUnit.id_municipality &&
          !store.state.municipality?.items?.length
        ) {
          await store.dispatch("municipality/getAll");
        }
      }
      fetchList();
    });

    // Watch para detectar cambios en el evaluationId
    watch(
      () => props.evaluationId,
      (newId, oldId) => {
        if (newId && newId !== oldId) {
          evaluation_id.value = props.evaluationId;
          loadFormData();
          if (evaluation_id.value) {
            templateSelected.value = currentEvaluation.value?.template;
            facilitySelected.value = currentEvaluation.value?.unit;
            disabledUnitSelect.value = true;
            fetchFormTracking(evaluation_id.value);

            // Reiniciar el formulario
            isAnsweringForm.value = false;
            setTimeout(() => {
              startAnsweringForm();
            }, 50);
          }
        }
      }
    );

    function returnTemplateId() {
      return templateSelected.value?.id ?? null;
    }

    function returnFacilityId() {
      return facilitySelected.value?.id ?? null;
    }

    function returnFacilityObj() {
      if (!facilitySelected.value) return {};

      const facility = facilitySelected.value;

      return {
        id: facility.id,
        description: facility.description,
        region: facility?.region?.name || "",
        subregion: facility?.sector?.name || "",
        categories: Array.isArray(facility.category)
          ? facility.category
          : [facility.category],
        sirh: facility.sirh || "",
        rems: facility.rems || "",
        id_seproban: facility.id_seproban || "",
        municipality:
          facility?.municipality?.name ||
          (facility?.id_municipality
            ? store.getters["municipality/getItemById"](facility.id_municipality)?.name ||
              ""
            : ""),
      };
    }

    return {
      templatesOptions,
      currentPage,
      lastPage,
      currentStep,
      totalSteps,
      templateSelected,
      referenceNumber,
      referenceShowed,
      facilitySelected,
      facilityOptions,
      templatePreview,
      isAnsweringForm,
      facilityName,
      templateName,
      disabledUnitSelect,
      idPrefill,
      showActionsButtons,
      comment,
      formStatus,
      userSelected,
      ownerOfForm,
      isOwnerOfForm,
      userOptions,
      validationComment,
      formValidationComment,
      formValidationRejectedAt,
      formValidationAt,
      isCreateSpecialForm,
      currentSpecialForm,
      currentFormStatus,
      anotherFacility,
      isShowAnotherFacility,
      reopenedComments,
      formHistory,
      isStatusBeingUpdated,
      isBauBatchInProgress,
      reopenedComment,
      formTracking,
      isLoadingTracking,
      isUserSupervisor,
      showReferenceNumber,
      isFormFromSameUser,
      evaluation_id,
      canUserSendToReview,
      canUserReopenForm,
      hasBauComplementsQuery,
      shouldHideReopenSection,
      currentEvaluation,
      isSignificantEvent,
      significantEventTitle,
      significantEventDescription,
      significantSecurityManager,
      regionalManagerOptions,
      relatedTemplates,
      recipientEmails,
      canRejectForm,
      canApproveForm,
      alarmType,
      buildFormComponent,
      isReadOnlyUser,
      isMarkerCheckerFlowAllowed,
      significantEventSecManagerComment,
      significantEventSecManagerCommentDate,
      canCloseFormManually,
      onSearch,
      isDark,
      fetchList,
      updateCurrentPage,
      checkRiskPercentage,
      setTemplatePreview,
      startAnsweringForm,
      returnTemplateId,
      returnFacilityId,
      returnFacilityObj,
      onAnswersSubmit,
      setFacilityConfig,
      submitError,
      sendToReview,
      sendBauNotificationTask,
      notifyAndCompleteBau,
      filterUserOption,
      sendEvaluationFormStatus,
      onAfterGetTemplate,
      reopenForm,
      // sendEmailForm,
      showAnotherFacility,
      navigateToForm,
      onDragStartFormTracking,
      validateGoBack,
      formatUser,
      getUserName,
      getUserEmail,
      formatDate,
      getStatusLabel,
      getStatusVariant,
      openAlarm,
      openCreateNewFormType,
      onChangeIsSignificantEvent,
      saveSignificantEventManagerComments,
      closeForm
    };
  },
};
</script>

<style scoped lang="scss">
.form-container {
  max-height: 540px;
  overflow: auto;
}

.comment-box {
  width: 450px;
}

/*info left, history right */
//.header-grid {
// max-width: 850px;
//}

.entity-link {
  cursor: pointer;
  color: #0052cc;
  text-decoration: none;
}

@media (max-width: 992px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: #f9fafb;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-row {
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 600;
  color: #444;
}

.info-value {
  color: #111;
  text-transform: none !important;
}

.timeline-container {
  margin-top: 0.5rem;
  padding-left: 0;
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  padding-bottom: 1.5rem;
  cursor: pointer;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-item:hover:not(.active-form) {
  transform: translateX(2px);
}

.timeline-item.active-form {
  cursor: default;
}

.timeline-item.active-form .timeline-content {
  background: #e3f2fd;
  border-left: 3px solid #2196f3;
}

.timeline-dot {
  position: absolute;
  left: 5px;
  top: 6px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #2196f3;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #2196f3;
}

.timeline-item.active-form .timeline-dot {
  background: #ff9800;
  box-shadow: 0 0 0 2px #ff9800;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: 10px;
  top: 18px;
  bottom: 0;
  width: 2px;
  background: #e0e0e0;
}

.timeline-item:last-child::before {
  display: none;
}

.timeline-content {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem;
  transition: all 0.2s ease;
}

.timeline-item:hover:not(.active-form) .timeline-content {
  border-color: #2196f3;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.15);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.timeline-reference {
  font-weight: 600;
  color: #1976d2;
  font-size: 0.9rem;
}

.timeline-badge {
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.badge-mailable {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge-standard {
  background: #f5f5f5;
  color: #616161;
}

.timeline-template {
  font-size: 0.85rem;
  color: #333;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.timeline-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #666;
}

.timeline-container::-webkit-scrollbar {
  width: 6px;
}

.timeline-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dark-layout {
  .info-card {
    background: #283046;
    border-color: #3b4253;
  }

  .info-label,
  .info-value {
    color: #b4b7bd;
  }

  .timeline-content {
    background: #283046;
    border-color: #3b4253;
  }

  .timeline-item:hover:not(.active-form) .timeline-content {
    border-color: #2196f3;
  }

  .timeline-item.active-form .timeline-content {
    background: #1e3a5f;
    border-left-color: #2196f3;
  }

  .timeline-reference {
    color: #64b5f6;
  }

  .timeline-template {
    color: #b4b7bd;
  }

  .timeline-meta {
    color: #8a8d93;
  }

  .badge-standard {
    background: #3b4253;
    color: #b4b7bd;
  }

  .timeline-container::-webkit-scrollbar-track {
    background: #161d31;
  }

  .timeline-container::-webkit-scrollbar-thumb {
    background: #555;
  }
}

.history-card {
  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 12px;
  overflow: hidden;
  min-width: 300px;
}

.history-header {
  margin-bottom: 8px;
}

.history-table {
  width: 100%;
}

.history-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;
}

.history-row-item-container {
  border-bottom: 1px dotted #e0e0e0;
}

.history-row-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 8px;
  align-items: center;
  padding: 10px 0;
}

.history-row-item__comments {
  font-size: 16px;
}

.history-row:last-child {
  border-bottom: 0;
}

.history-row--head {
  border-bottom: 1px solid #e9ecef;
  font-weight: 600;
  color: #444;
  padding-top: 0;
  padding-bottom: 8px;
}

.col-state {
  justify-self: start;
}

.col-user {
  justify-self: start;
  min-width: 0;
}

.col-date {
  justify-self: end;
  white-space: nowrap;
  overflow: visible;
}

.history-row--head > div,
.history-row > .col-user {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-note {
  white-space: normal;
  overflow: hidden;
}

.history-badge {
  display: inline-flex;
  align-items: center;
}

.history-date {
  font-size: 12px;
  color: #6c757d;
  font-variant-numeric: tabular-nums;
}

.content-grid {
  display: block;
}
.customBadgeForm {
  display: inline-block;
  font-size: 85%;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: baseline;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background 0s, border 0s;
  padding: 0.3rem 0.5rem;
  text-align: center;
  border-radius: 50px;
  color: #fff;
  margin-left: 5px;
  margin-right: 5px;
}
</style>
